import _extends from "@babel/runtime/helpers/extends";
import * as AddToBasket from '@ori-events/add-to-basket';
export var Name = 'loyalty-dialog-result';
export var LoyaltyDialogResultEvent = Name;
var LoyaltyDialogResults;

(function (LoyaltyDialogResults) {
  LoyaltyDialogResults["CLOSE"] = "CLOSE";
})(LoyaltyDialogResults || (LoyaltyDialogResults = {}));

export var Result = _extends({}, AddToBasket.Method, {}, LoyaltyDialogResults);
export var isLoyaltyBuyForMoneyResult = function isLoyaltyBuyForMoneyResult(result) {
  return result === Result.BUY_FOR_MONEY;
};
export var isLoyaltyBuyForPointsResult = function isLoyaltyBuyForPointsResult(result) {
  return result === Result.BUY_FOR_POINTS;
};
export var isLoyaltyCloseResult = function isLoyaltyCloseResult(result) {
  return result === Result.CLOSE;
};